import React, { FC } from 'react';
import { WebRefType } from '$constants';
import { IWebRef } from '$models';
import { AudioRef } from './components/audio-ref';
import { ReadRef } from './components/read-ref';
import { VideoRef } from './components/video-ref';
import { YoutubeRef } from './components/youtube-ref';

type Props = {
    webRef: IWebRef;
    productTitle?: string;
};

export const WebRef: FC<Props> = ({ webRef, productTitle }: Props): JSX.Element => {
    const renderModalContent = (webRef: IWebRef) => {
        switch (webRef.type) {
            case WebRefType.ReadSample:
                return <ReadRef data={webRef} productTitle={productTitle} />;
            case WebRefType.SoundSample:
                return <AudioRef data={webRef} productTitle={productTitle} />;
            case WebRefType.VideoSample:
                return <VideoRef data={webRef} />;
            case WebRefType.youtube:
                return <YoutubeRef data={webRef} />;
            case WebRefType.vimeo:
            case WebRefType.Unknown:
            default:
                return <></>;
        }
    };

    if (!webRef.uri) {
        return <></>;
    }

    return <>{renderModalContent(webRef)}</>;
};
